export class WebError extends Error {
    constructor(body, status) {
        super(`${status} error`)
        Error.captureStackTrace(this, this.constructor)

        this.name = 'WebError'
        this.body = body
        this.status = status
    }
}
